/*
export default defineNuxtPlugin(() => {
  if (typeof window !== 'undefined') {
    // Skip execution on localhost
    /!* if (window.location.href.includes('localhost')) {
      return;
    } *!/

    const isMobile = window.innerWidth < 768;

    // Initialize Tawk.to settings
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    // Set custom styles for the widget
    window.Tawk_API.customStyle = {
      visibility: {
        desktop: {
          position: 'bl',
          xOffset: '20px',
          yOffset: !isMobile ? '30px' : '55px',
        },
        mobile: {
          position: 'bl',
          xOffset: '20px',
          yOffset: '55px',
        },
        bubble: {
          rotate: '0deg',
          xOffset: 0,
          yOffset: 0,
        },
      },
    };

    const originalBottomValues = new Map();

    const adjustTawkIframePosition = () => {
      const stickyBar = document.querySelector('.sticky-bar');
      const isStickyBarVisible = stickyBar && stickyBar.offsetParent !== null;

      const tawkIframes = document.querySelectorAll('.widget-visible iframe');

      tawkIframes.forEach((iframe) => {
        if (iframe.style.position === 'fixed' && iframe.style.bottom) {
          if (!originalBottomValues.has(iframe)) {
            const originalBottom = parseFloat(iframe.style.bottom);
            originalBottomValues.set(iframe, originalBottom);
          }

          const originalBottom = originalBottomValues.get(iframe);
          let newBottom = originalBottom;

          if (isStickyBarVisible) {
            newBottom = originalBottom + 54;
          }

          iframe.style.bottom = `${newBottom}px`;
        }
      });
    };

    // Function to load Tawk.to script non-blockingly
    const loadTawkScript = () => {
      const s1 = document.createElement('script');
      s1.async = true;
      s1.defer = true;
      s1.src = 'https://embed.tawk.to/66ef20ee4cbc4814f7dce14a/1i8b1h99c';
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');

      s1.onload = () => {
        adjustTawkIframePosition();

        const observer = new MutationObserver(adjustTawkIframePosition);
        const config = { attributes: true, childList: true, subtree: true };

        const stickyBar = document.querySelector('.sticky-bar');
        if (stickyBar) {
          observer.observe(stickyBar, config);
        }

        window.addEventListener('scroll', adjustTawkIframePosition);
        window.addEventListener('resize', adjustTawkIframePosition);

        const tawkContainer = document.querySelector('.widget-visible');
        if (tawkContainer) {
          const iframeObserver = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
              if (mutation.type === 'childList') {
                adjustTawkIframePosition();
              }
            }
          });
          iframeObserver.observe(tawkContainer, { childList: true, subtree: true });
        }
      };

      document.head.appendChild(s1);
    };

    // Use requestIdleCallback if available, else fallback to setTimeout
    /!*if ('requestIdleCallback' in window) {
      requestIdleCallback(loadTawkScript);
    } else {*!/
      setTimeout(loadTawkScript, 5000);
/!*    }*!/
  }
});
*/

// Keep this file intentionally inactive while still exposing a valid Nuxt plugin.
// Without a default export Nuxt logs a build warning and ignores the file.
export default defineNuxtPlugin(() => {});
